import React from 'react';
import { Button, CircularProgress, Collapse, makeStyles, useTheme } from '@material-ui/core';
import { Alert } from '@material-ui/lab';
import { styles } from './notificationMessage.styles';
import { generateUniqueKeyWithNoPrefix } from '../../helpers';
import { CheckCircle, Info, ReportProblem } from '@material-ui/icons';

export interface NotificationMessageProps {
  message: string;
  icon?: NotificationMessageIcons | undefined;
  actions?: NotificationAction[];
  onClose?: () => void;
}

export type NotificationAction = {
  label: string;
  onClick: () => void;
};

export enum NotificationMessageIcons {
  SUCCESS,
  INFO,
  ERROR,
  NONE,
  LOADING
}

const NotificationMessage: React.FC<NotificationMessageProps> = ({
  message,
  icon,
  actions = undefined,
  onClose = undefined
}) => {
  const currentTheme = useTheme();
  const useStyles = makeStyles(styles(currentTheme));
  const classes = useStyles();
  const [open] = React.useState(true);

  const customAction =
    actions &&
    actions.map(action => (
      <Button
        key={generateUniqueKeyWithNoPrefix()}
        className={classes.action}
        color="primary"
        size="small"
        onClick={() => {
          action.onClick();
        }}
      >
        {action.label}
      </Button>
    ));

  const getIcon = React.useCallback(() => {
    switch (icon) {
      case NotificationMessageIcons.NONE:
        return false;
      case NotificationMessageIcons.SUCCESS:
        return <CheckCircle fontSize="small" />;

      case NotificationMessageIcons.INFO:
        return <Info fontSize="small" />;

      case NotificationMessageIcons.ERROR:
        return <ReportProblem fontSize="small" color="error" />;

      case NotificationMessageIcons.LOADING:
        return <CircularProgress size={15} />;

      default:
        return false;
    }
  }, [icon]);

  return (
    <>
      {open && (
        <Collapse in={open}>
          <Alert
            severity={undefined}
            onClose={onClose}
            icon={getIcon()}
            action={customAction}
            className={classes.alert}
          >
            {message}
          </Alert>
        </Collapse>
      )}
    </>
  );
};

export default NotificationMessage;
